import DOMPurify from 'dompurify';
/**
 * Initialize the global filters based on URL parameters.
 */
export default async () => {
	await new Promise((resolve) => {
		const urlParams = new URLSearchParams(window.location.search);
		const orderFilter = document.querySelector('.js-gsfc-filter-order');
		const orderFiltersAllowed = [];
		orderFilter.querySelectorAll('option').forEach((option) => {
			orderFiltersAllowed.push(option.value);
		});

		const taxFilters = document.querySelectorAll(
			'.js-gsfc-filter-tax-select'
		);
		const allowedTaxonomies = [];
		taxFilters.forEach((filter) => {
			filter.querySelectorAll('option').forEach((option) => {
				allowedTaxonomies.push(option.value);
			});
		});
		const allowedPostTypes = [];
		document
			.querySelectorAll('.js-gsfc-filter-post-type')
			.forEach((filter) => {
				allowedPostTypes.push(filter.innerHTML);
			});

		function updateFiltersFromSearchParams(searchParams, filters) {
			for (let [key, value] of searchParams) {
				//Sanitse everything.
				value = DOMPurify.sanitize(value, { ALLOWED_TAGS: ['#text'] });

				// Ensure the order value is allowed
				if (key === 'order' && !orderFiltersAllowed.includes(value)) {
					value = '';
				}

				//Ensure dates are in the correct format
				if (key === 'date_range_from' || key === 'date_range_to') {
					const date = new Date(value);
					if (date instanceof Date && !isNaN(date)) {
						value = date.toISOString().split('T')[0];
					} else {
						value = '';
					}
				}

				// Special handling for arrays to support multiple values
				if (key === 'post_types' && value) {
					// Check if the value is already included to avoid duplicates
					if (
						!filters.post_types.includes(value) &&
						allowedPostTypes.includes(value)
					) {
						filters.post_types.push(value);
					}
					// eslint-disable-next-line no-prototype-builtins
				} else if (value && filters.hasOwnProperty(key)) {
					// Update the value if it exists in the filters object and is not empty
					// Direct assignment works for all non-array fields
					filters[key] = value;
				}
				// For boolean fields, convert string to boolean
				if (key === 'query_post_types') {
					filters[key] = value.toLowerCase() === 'true';
				}
				// Special handling for objects stored as JSON strings
				if (key.includes('_')) {
					const [mainKey, subKey] = key.split('_');
					// eslint-disable-next-line no-prototype-builtins
					if (!filters.hasOwnProperty(mainKey)) {
						filters[mainKey] = {};
					}
					// Only attempt JSON parsing if the value appears to be a JSON string
					if (value.startsWith('{') || value.startsWith('[')) {
						try {
							const decoded = JSON.parse(
								decodeURIComponent(value)
							);
							decoded.terms.foreach((term) => {
								// Ensure the taxonomy value is allowed
								if (allowedTaxonomies.includes(term[0])) {
									filters[mainKey][subKey].push(term);
								}
							});
							// eslint-disable-next-line
            } catch (error) {
							//console.error(
							//	`Error parsing JSON for ${ key }: ${ error }`
							//);
						}
					}
				}
			}
			return filters;
		}

		global.filters = updateFiltersFromSearchParams(
			urlParams,
			global.filters
		);
		resolve();
	});
};
